import { FeaturedResponse, ProfileType } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { LeMagAction, LeMagActionTypes } from "./LeMag";
import { getFeaturedArticles } from "@blacknut/javascript-sdk/dist/api/LeMag/getFeaturedArticles";
export const paginateArticles = (
  page = 1,
  limit = 10,
  userProfile = ProfileType.GENERIC,
) => {
  return (dispatch: Dispatch<LeMagAction>) => {
    return new Promise<FeaturedResponse>((resolve, reject) => {
      dispatch({ type: LeMagActionTypes.ARTICLES_PAGINATE_REQUEST });
      getFeaturedArticles(page, limit, userProfile).subscribe({
        next: (response) => {
          dispatch({ type: LeMagActionTypes.ARTICLES_PAGINATE_SUCCESS, response });
          resolve(response);
        },
        error: (error) => {
          dispatch({ type: LeMagActionTypes.ARTICLES_PAGINATE_ERROR, error });
          reject(error);
        },
      });
    });
  };
};
